"use client"

import { useRouter } from "next/navigation"

export function TheClose() {
  const router = useRouter()

  return (
    <section
      className="flex items-center justify-center px-6 py-28 sm:py-36"
      style={{ backgroundColor: "var(--brand-white-hills)" }}
    >
      <div className="mx-auto max-w-md text-center">
        <h2
          className="font-[var(--font-instrument-serif)] text-[24px] italic sm:text-[28px]"
          style={{ color: "var(--brand-graphite)" }}
        >
          Curious what your conversations know?
        </h2>

        <button
          onClick={() => router.push("/upload")}
          className="btn-star mt-10 rounded-full px-10 py-4 text-lg"
        >
          See Your Mind
        </button>

        <p
          className="mt-5 text-[14px]"
          style={{ color: "var(--brand-cliff)" }}
        >
          Instant preview. Full analysis &euro;25 one-time. Your results
          are yours forever.
        </p>
      </div>
    </section>
  )
}
